module.exports = __webpack_public_path__ + "img/img_introduction_01.2ebcf54c.png";